// Global currency configuration store
var currencyConfig = {
  defaultCurrency: '',
  showOppositeCurrency: true
};
export var setCurrencyConfig = function setCurrencyConfig(config) {
  currencyConfig = config;
};
export var getCurrencyConfig = function getCurrencyConfig() {
  return currencyConfig;
};
export var shouldShowOppositeCurrency = function shouldShowOppositeCurrency() {
  var _currencyConfig;

  return ((_currencyConfig = currencyConfig) === null || _currencyConfig === void 0 ? void 0 : _currencyConfig.showOppositeCurrency) === '1';
};